var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.position && _vm.position.hitZones && _vm.position.hitZones.length ? _c('div', [_vm.hitZonesZones.length ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.hitZonesZonesText)
    }
  }) : _vm._e(), _vm.hitZonesComponents.length ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.hitZonesComponentsText)
    }
  }) : _vm._e()]) : _c('div');
}
var staticRenderFns = []

export { render, staticRenderFns }